import { IResellerModifiedUnion } from 'src/@interfaces'

type GetSlugOrStateParams = {
  reseller: IResellerModifiedUnion | undefined
  isGenericReseller: boolean
}

export const getSlugOrState = ({ reseller, isGenericReseller }: GetSlugOrStateParams) => {
  if (reseller && !isGenericReseller) {
    const { catalogSlug } = reseller
    return { catalogSlug }
  }

  const state = localStorage.getItem('state')
  return { state }
}
